<template>
    <v-dialog v-model="followupDateDialog" max-width="400">
        <v-card class="no-padding">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="cancel">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Follow up details</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-menu
                                ref="dateMenu"
                                v-model="dateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="followupDate"
                                        label="Followup Date"
                                        prepend-icon="event"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        :rules="[$rules.required]"
                                    ></v-text-field>
                                </template>
                                <v-date-picker 
                                    v-model="followupDate"
                                    scrollable
                                    @input="dateMenu = false"
                                >
                                </v-date-picker>
                            </v-menu>
                            <v-select
                                :items="vetUsers"
                                item-text="Email"
                                item-value="Email"
                                v-model="selectedVet"
                                label="Assign to Vet">

                            </v-select>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-container>
                    <v-row no-gutters>
                        <v-col cols="12" md="6" offset-md="3">
                            <v-alert text type="error" v-if="errorMessage">
                                {{errorMessage}}
                            </v-alert> 
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12" md="6" offset-md="3">
                            <v-row>
                                <v-col cols="6">
                                    <v-btn color="primary darken-1" @click="save()" :disabled="saving||!followupDate.length>0" :loading="saving" block>Save</v-btn>
                                </v-col>
                                <v-col cols="6">
                                    <v-btn color="warning" @click="cancel" block>Cancel</v-btn>
                                </v-col>
                            </v-row>
                            <v-spacer></v-spacer>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import moment from 'moment';
import validationRules from '../../helpers/validationrules';
import { mapGetters } from 'vuex';

export default {
    props: {
        followupDateDialog: {
            type: Boolean,
            default: false
        },
        medicalRecordID: {
            type: String,
            default: ""
        },
    } ,
    data() {
        return {
            errorMessage: "",
            saving: false,
            dateMenu: false,
            followupDate: "",
            rules: validationRules,
            selectedVet: null
        };
    },
    computed: {
        ...mapGetters({
            vetUsers: "userStore/getVetUsers",
        }),
    },
    methods: {
        async save() {
            this.errorMessage = "";
            this.saving = true;
            await this.$emit("save", true, this.followupDate, this.selectedVet);
            this.saving = false;
            this.$emit('cancel');
        },
        cancel() {
            this.$emit('cancel');
        }
    }
}
</script>